import { z } from "zod/v4";
/** 率 (0~1) を扱う */
const RateSchema = z.number().min(0).max(1).brand();
export const Rate = {
    schema: RateSchema,
    of(args) {
        return Rate.schema.parse(args);
    },
};
//# sourceMappingURL=rate.js.map